import { render, staticRenderFns } from "./PaymentAllocationRecord.vue?vue&type=template&id=c7112f62&"
import script from "./PaymentAllocationRecord.vue?vue&type=script&lang=js&"
export * from "./PaymentAllocationRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports